import type { ProductWithHelpers } from '@shared/products-core';
import { isCreditCard } from '@shared/products-core';
import { t } from '@luna/i18n';

export const getStatementColumnLabel = (
    isGlobalSearch: boolean,
    product?: ProductWithHelpers,
): string => {
    const isCreditCardProduct = product ? isCreditCard(product) : false;

    if (isGlobalSearch) {
        return t('transaction.list.column.statementInvoice');
    }

    if (isCreditCardProduct) {
        return t('transaction.list.column.invoice');
    }

    return t('transaction.list.column.statement');
};
